import React from 'react';
import classNames from 'classnames';

const EngineIcon = ({
  className,
  fill,
  size,
  ...rest
}) => (
  <svg className={classNames(`w-${size} h-${size}`, className)} fill={fill} aria-label="model" viewBox="0 0 90 90" {...rest}>
    <path d="M80.7,31.2h-9.4c-1.4,0-3,1.4-3,2.7v3h-2.4v-3.2c0-1-0.9-1.7-1.9-1.9h-4.6l-2-4.2c-0.7-1.3-2-2.3-3.6-2.3h-7.1v-2.9h5.5  c1.4,0,2.6-1.4,2.6-2.9c0-1.4-1.2-2.9-2.6-2.9H36c-1.4,0-2.6,1.4-2.6,2.9c0,1.4,1.2,2.9,2.6,2.9h6.3v2.9h-7.1  c-1.4,0-2.7,0.9-3.5,2.2l-2.2,3.7L21.2,31l0,0c-1.4,0-3.3,1.7-3.3,3.2V44h-1.4V32.9c0-1.6-1.3-2.9-2.9-2.9s-2.9,1.3-2.9,2.9v28.8  c0,1.6,1.3,2.9,2.9,2.9s2.9-1.3,2.9-2.9V48.5h1.4v9.2c0,1.4,1.9,2.3,3.3,2.3h8.9l6.8,7.3c0.6,0.6,1.4,1.3,2.3,1.3H64  c1.7,0,3.2-1.9,3.2-3.6v-7.9h1.4v3.2c0,1.3,1.6,2.6,2.7,2.6h9.8c1.3,0,1.7-1.3,1.7-2.6V33.9C82.8,32.6,82.1,31.2,80.7,31.2z   M77.1,57.1h-2.9v-5.8H69h-1.9h-5.8v6.2v5.3h-21l-5.9-6.6l-1.7-2h-2.4h-6.5V37.5h5.6H33l1.7-3.2l1.7-3.2h16.3l1.6,3.2l1.6,3.2  l3.5,0.1l0.9-0.1l0.1,5.2H66h2.9H74v-5.5v-0.3h2.9v20.2H77.1z" />
  </svg>
)

export default EngineIcon;
